import React from 'react';
import cn from 'classnames';
import type { FormatOptionLabelMeta } from 'react-select';

import { getTranslation } from 'helpers/getTranslation';

import { Select } from 'components/shared/Select';
import { Typography } from 'components/shared/Typography';

import { SchoolPreview } from 'components/SchoolPreview';

import type { LessonRatingsCourseOption } from '../LessonRatingsCard.helpers';

import styles from './LessonRatingsCourseSelect.module.scss';

const formatOptionLabel = (
  option: LessonRatingsCourseOption,
  { context }: FormatOptionLabelMeta<LessonRatingsCourseOption>,
) => {
  const isValueContext = context === 'value';

  return (
    <span
      className={cn(styles.optionContent, {
        [styles.optionContentCompact]: isValueContext,
      })}
    >
      {option.school ? (
        <SchoolPreview
          className={cn(styles.schoolPreview, {
            [styles.schoolPreviewMenu]: !isValueContext,
          })}
          preview={option.school.preview}
          name={option.school.name}
        />
      ) : null}
      <span className={styles.optionInfo}>
        {!isValueContext && option.school ? (
          <Typography
            className={styles.schoolName}
            variant="caption"
            mode="compact"
            component="span"
          >
            {option.school.name}
          </Typography>
        ) : null}
        <Typography
          className={styles.courseTitle}
          variant="body3"
          weight="medium"
          mode="compact"
          component="span"
        >
          {option.courseTitle}
        </Typography>
        {!isValueContext && option.typeLabel ? (
          <Typography
            className={styles.courseType}
            variant="caption"
            mode="compact"
            component="span"
          >
            {option.typeLabel}
          </Typography>
        ) : null}
      </span>
    </span>
  );
};

const LessonRatingsCourseSelect = ({
  className,
  options,
  value,
  onChange,
}: {
  className?: string;
  options: LessonRatingsCourseOption[];
  value: LessonRatingsCourseOption | null;
  onChange: (option: LessonRatingsCourseOption) => void;
}) => (
  <div className={cn(styles.root, className)}>
    <Typography className={styles.label} component="span">
      {getTranslation('dashboard_page.select_course.label')}
    </Typography>
    <Select
      className={styles.select}
      value={value}
      options={options}
      formatOptionLabel={formatOptionLabel}
      onChange={onChange}
    />
  </div>
);

export default React.memo(LessonRatingsCourseSelect) as any;
